export const loadIsExpectedError = () =>
  import(
    /* webpackChunkName: "4-feat-is-expected-error" */
    './isExpectedError'
  );
